export const ALLOWED_MESSAGE_PLANS = [
  { value: 60, setValue: 50 },
  { value: 120, setValue: 100 },
  { value: 180, setValue: 150 },
  { value: 240, setValue: 200 },
  { value: 360, setValue: 300 },
  { value: 600, setValue: 500 },
  { value: 1200, setValue: 1000 },
];

export const ALLOWED_MESSAGE_SET_VALUES = ALLOWED_MESSAGE_PLANS.map(
  (plan) => plan.setValue
);

export const snapToAllowedMessageSetPrice = (value: number) => {
  return ALLOWED_MESSAGE_SET_VALUES.reduce((prev, curr) =>
    Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev
  );
};

export const mapMessageSetPriceToActualPrice = (setPrice: number): number => {
  const plan = ALLOWED_MESSAGE_PLANS.find((p) => p.setValue === setPrice);
  return plan ? plan.value : setPrice;
};

export const getMessageSetPriceFromActualPrice = (
  actualPrice: number
): number => {
  const plan = ALLOWED_MESSAGE_PLANS.find((p) => p.value === actualPrice);
  return plan ? plan.setValue : actualPrice;
};